import { Message } from "../../../domain/model/Auth";
import {
  CategoryEntity,
  CategoryUnlockCode,
  UnlockCategoryRequestModel,
} from "../../../domain/model/Category";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { CategoryRepository } from "./CategoryRepository";

export class CategoryRepositoryImpl implements CategoryRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getCategories(
    filterHiddenOnes: boolean
  ): Promise<Response<Array<CategoryEntity>>> {
    return this.apiService.getCategories(filterHiddenOnes);
  }

  unlockCategory(
    model: UnlockCategoryRequestModel,
    isUnlockedInReference?: boolean
  ): Promise<Response<Array<CategoryUnlockCode>>> {
    return this.apiService.unlockCategory(model, isUnlockedInReference);
  }
  getCategoryUnlockCode(id: string): Promise<Response<CategoryUnlockCode>> {
    return this.apiService.getCategoryUnlockCode(id);
  }
}
